import React, { Component } from 'react';
import axios from 'axios'
import { Checkbox } from 'antd';
import { notifyUser, type } from '../utility/notifyUser';
import { connect } from 'react-redux';
import styles from './search.module.css'
import { ButtonStyle } from '../UIElements/Buttons/ButtonStyle';
import authservice from '../Authentication/service/authservice';


class Search extends Component {

    constructor(props) {
        super(props);
        this.hideBar = this.hideBar.bind(this);
        this._isMounted = false;
        this.state = {
            show: false,
            subCategoryOptions: [],
            categoryOptions: [],
            stateOptions: [],
            cityOptions: [],
            localityOptions: [],
            neighbourhoodOptions: [],
            radius: 0,
            keyword: '',
            location: '',
            activeMenu: '',
            searchActiveMenu: '',
            selectedCategory: [],
            selectedSubCategory: [],
            selectedState: [],
            selectedCity: [],
            selectedLocality: [],
            selectedNeighbourhood: [],
            showMenu: false,
            userId: authservice.getCurrentUserid(),
            guestId: authservice.getCookie('hp.rocks.soon'),
            ismobile: window.innerWidth <= 991,
            advancedSearch: false
        };
        this.allStates = [];
        this.allCategories = [];
        this.categoryOptionsList = [];
        this.subCategoryOptionsList = [];
        this.stateOptionsList = [];
        this.cityOptionsList = [];
        this.localityOptionsList = [];
    }

    hideBar() {
        if (this.props.isMobile) {
            this.state.isHide && this.setState({ isHide: false })
            return
        }
        let { isHide } = this.state
        window.scrollY > this.prev ?
            !isHide && this.setState({ isHide: true, activeMenu: '' })
            :
            isHide && this.setState({ isHide: false })

        this.prev = window.scrollY;
    }

    componentWillUnmount = () => {
        this._isMounted = false;
        window.removeEventListener('scroll', this.hideBar)
        window.removeEventListener('resize', this.handleResize);
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.is_login != this.props.is_login && !this.props.is_login) {
            this.resetSearchCriteria();
        }
    }

    componentDidMount() {
        this._isMounted = true;
        !this.props.isMobile && window.addEventListener('scroll', this.hideBar);
        window.addEventListener('resize', this.handleResize);
    }

    catState = () => {
        Promise.all([
            axios.get(process.env.REACT_APP_BACKEND_URL + '/hpmgr/listing/listings-states'),
            axios.get(process.env.REACT_APP_BACKEND_URL + '/hpmgr/listing/listings-categories')
        ]).then(([getFullAddress, getAllCategories]) => {
            this.allStates = getFullAddress.data; this.allCategories = getAllCategories.data

            //let classHide = this.state.isHide ? "hide-search-bar" : ""
            const categoryOptions = this.allCategories.map(item => {
                return { value: item.category, label: this.titleCase(item.category) };
            })
            categoryOptions.sort((a, b) => (a.label > b.label) ? 1 : -1)
            let categoryList = [];
            categoryOptions.forEach(function iter(r) {
                return function (o) {
                    var ref = r.find(p => o.label.toLowerCase() === p.label.toLowerCase());
                    if (!ref) {
                        r.push(o);
                        return;
                    }
                    Object
                        .keys(o)
                        .filter(k => Array.isArray(o[k]))
                        .forEach(k => o[k].forEach(iter(ref[k] = ref[k] || [])));
                };
            }(categoryList));
            this.categoryOptionsList = categoryList;
            this._isMounted && this.setState({ categoryOptions: categoryList })

            //let classHide = this.state.isHide ? "hide-search-bar" : ""

            const stateOptions = this.allStates.map(item => {
                return ({ value: item.state, label: this.titleCase(item.state) })
            })
            stateOptions.sort((a, b) => (a.label > b.label) ? 1 : -1)
            let stateList = [];
            stateOptions.forEach(function iter(r) {
                return function (o) {
                    var ref = r.find(p => o.label.toLowerCase() === p.label.toLowerCase());
                    if (!ref) {
                        r.push(o);
                        return;
                    }
                    Object
                        .keys(o)
                        .filter(k => Array.isArray(o[k]))
                        .forEach(k => o[k].forEach(iter(ref[k] = ref[k] || [])));
                };
            }(stateList));
            this.stateOptionsList = stateList;
            this._isMounted && this.setState({ stateOptions: stateList })

            // let classHide = this.state.isHide ? "hide-search-bar" : ""

        }).catch(error => {
            console.log(error, 'getting data failed');
        });
    }


    handleResize = () => {
        this.setState({ ismobile: window.innerWidth <= 950 });
    };

    handleFilterSearch = (text) => {
        this.setState({ searchText: text })

        switch (this.state.activeMenu) {
            case 'category':
                this.setState({
                    categoryOptions: this.categoryOptionsList.filter(el => {
                        return el.value.toLowerCase().includes(text.toLowerCase())
                    })
                })
                break;
            case 'subcategory':
                const tempList = []
                this.subCategoryOptionsList.forEach(el => {
                    tempList.push({
                        label: el.label,
                        options: el.options.filter(op => {
                            return op.label.toLowerCase().includes(text.toLowerCase())
                        })
                    })
                })
                this.setState({ subCategoryOptions: tempList })
                break;
            case 'state':
                this.setState({
                    stateOptions: this.stateOptionsList.filter(el => {
                        return el.value.toLowerCase().includes(text.toLowerCase())
                    })
                })
                break;
            case 'city':
                const tempCityList = []
                this.cityOptionsList.forEach(el => {
                    tempCityList.push({
                        label: el.label,
                        options: el.options.filter(op => {
                            return op.label.toLowerCase().includes(text.toLowerCase())
                        })
                    })
                })
                this.setState({ cityOptions: tempCityList })
                break;
            case 'locality':
                const tempLocalityList = []
                this.localityOptionsList.forEach(el => {
                    tempLocalityList.push({
                        label: el.label,
                        options: el.options.filter(op => {
                            return op.label.toLowerCase().includes(text.toLowerCase())
                        })
                    })
                })
                this.setState({ localityOptions: tempLocalityList })
                break;
            case 'neighbourhood':
                const tempNeighbourhoodList = []
                this.neighbourhoodOptionsList.forEach(el => {
                    tempNeighbourhoodList.push({
                        label: el.label,
                        options: el.options.filter(op => {
                            return op.label.toLowerCase().includes(text.toLowerCase())
                        })
                    })
                })
                this.setState({ neighbourhoodOptions: tempNeighbourhoodList })
            default:
                break;
        }
    }

    getSortedOptions = (optionsList) => {
        let groupedList = this.grouping(optionsList);

        groupedList.sort((a, b) => {
            const t1 = a.label.toUpperCase();
            const t2 = b.label.toUpperCase();
            let comparison = 0;
            if (t1 > t2) {
                comparison = 1;
            } else if (t1 < t2) {
                comparison = -1;
            }
            return comparison;
        })

        groupedList.forEach(group => {
            group.options.sort((a, b) => {
                const t1 = a.value.toUpperCase();
                const t2 = b.value.toUpperCase();
                let comparison = 0;
                if (t1 > t2) {
                    comparison = 1;
                } else if (t1 < t2) {
                    comparison = -1;
                }
                return comparison;
            })
        })

        return groupedList;
    }

    handleCategory = (status, category) => {
        let selectedCategory = [...this.state.selectedCategory]
        if (status)
            selectedCategory.push(category)
        else {
            selectedCategory = this.state.selectedCategory.filter(c => {
                return c !== category
            })
            this.setState({
                selectedSubCategory: this.state.selectedSubCategory.filter(sub => {
                    return sub.group !== category
                })
            })
        }

        this.handleFilterSearch('')

        let subCategoryOptions = [];

        selectedCategory.forEach(data => {
            this.allCategories.forEach(cat => {
                if (cat.category === data) {
                    subCategoryOptions.push({
                        label: this.titleCase(data),
                        options: (cat.subCategory != null) ? [
                            { value: cat.subCategory, label: this.titleCase(cat.subCategory), group: data }
                        ] : []
                    })
                }
            })
        })

        this.subCategoryOptionsList = this.getSortedOptions(subCategoryOptions)
        this.setState({ selectedCategory, subCategoryOptions: this.subCategoryOptionsList })
    }

    handleSubCategory = (status, subCatgeory) => {
        let selectedSubCategory = [...this.state.selectedSubCategory]
        if (status)
            selectedSubCategory.push(subCatgeory)
        else {
            selectedSubCategory = selectedSubCategory.filter(subCat => {
                return !(subCat.value === subCatgeory.value && subCat.group === subCatgeory.group)
            })
        }
        this.handleFilterSearch('')
        this.setState({ selectedSubCategory })
    }

    handleState = (status, state) => {
        let selectedState = [...this.state.selectedState]
        if (status)
            selectedState.push(state)
        else {
            selectedState = this.state.selectedState.filter(s => {
                return s !== state
            })
            let selectedCity = [...this.state.selectedCity];
            let selectedLocality = [...this.state.selectedLocality];
            let selectedNeighbourhood = [...this.state.selectedNeighbourhood];

            selectedCity = selectedCity.filter(city => {
                if (city.group !== state)
                    return true;
                else {
                    selectedLocality = selectedLocality.filter(locality => {
                        if (locality.group !== city.value)
                            return true;
                        else {
                            selectedNeighbourhood = selectedNeighbourhood.filter(neigh => {
                                return neigh.group !== locality.value
                            })
                        }
                    })
                }
            })

            this.handleFilterSearch('')

            let localityOptions = [];
            selectedCity.forEach(data => {
                this.allStates.forEach(state => {
                    if (state.state === data.group && state.city === data.value) {
                        localityOptions.push({
                            label: this.titleCase(data.label),
                            options: (state.locality !== null) ? [
                                { value: state.locality, label: this.titleCase(state.locality), group: data.value }
                            ] : []
                        })
                    }
                })
            })

            let neighbourhoodOptions = [];
            selectedLocality.forEach(data => {
                this.allStates.forEach(state => {
                    if (state.city === data.group && state.locality === data.value) {
                        neighbourhoodOptions.push({
                            label: this.titleCase(data.label),
                            options: (state.neighbourhood !== null) ? [
                                { value: state.neighbourhood, label: this.titleCase(state.neighbourhood), group: data.value }
                            ] : []
                        })
                    }
                })
            })
            this.setState({
                selectedCity, selectedLocality, selectedNeighbourhood,
                localityOptions: this.getSortedOptions(localityOptions),
                neighbourhoodOptions: this.getSortedOptions(neighbourhoodOptions)
            })
        }

        let cityOptions = [];
        this.allStates.forEach(state => {
            if (selectedState.includes(state.state)) {
                cityOptions.push({
                    label: this.titleCase(state.state),
                    options: (state.city !== null) ? [
                        { value: state.city, label: this.titleCase(state.city), group: state.state }
                    ] : []
                })
            }
        })
        this.handleFilterSearch('')
        this.cityOptionsList = this.getSortedOptions(cityOptions)
        this.setState({ selectedState, cityOptions: this.getSortedOptions(cityOptions) })
    }

    handleCity = (status, city) => {
        let selectedCity = [...this.state.selectedCity]
        if (status)
            selectedCity.push(city)
        else {
            selectedCity = selectedCity.filter(c => {
                return !(c.value === city.value && c.group === city.group)
            })
            let selectedLocality = [...this.state.selectedLocality];
            let selectedNeighbourhood = [...this.state.selectedNeighbourhood];
            selectedLocality = selectedLocality.filter(locality => {
                if (locality.group !== city.value)
                    return true;
                else {
                    selectedNeighbourhood = selectedNeighbourhood.filter(neigh => {
                        return neigh.group !== locality.value
                    })
                }
            })

            let neighbourhoodOptions = [];
            selectedLocality.forEach(data => {
                this.allStates.forEach(state => {
                    if (state.city === data.group && state.locality === data.value) {
                        neighbourhoodOptions.push({
                            label: this.titleCase(data.label),
                            options: (state.neighbourhood !== null) ? [
                                { value: state.neighbourhood, label: this.titleCase(state.neighbourhood), group: data.value }
                            ] : []
                        })
                    }
                })
            })
            this.handleFilterSearch('')
            this.setState({ selectedLocality, selectedNeighbourhood, neighbourhoodOptions: this.getSortedOptions(neighbourhoodOptions) })
        }

        let localityOptions = [];
        selectedCity.forEach(data => {
            this.allStates.forEach(state => {
                if (state.state === data.group && state.city === data.value) {
                    localityOptions.push({
                        label: this.titleCase(data.label),
                        options: (state.locality !== null) ? [
                            { value: state.locality, label: this.titleCase(state.locality), group: data.value }
                        ] : []
                    })
                }
            })
        })
        this.handleFilterSearch('')
        this.localityOptionsList = this.getSortedOptions(localityOptions)
        this.setState({ selectedCity, localityOptions: this.getSortedOptions(localityOptions) })
    }

    handleLocality = (status, locality) => {
        let selectedLocality = [...this.state.selectedLocality]
        if (status)
            selectedLocality.push(locality)
        else {
            selectedLocality = selectedLocality.filter(l => {
                return !(l.group === locality.group && l.value === locality.value)
            })
            this.setState({
                selectedNeighbourhood: this.state.selectedNeighbourhood.filter(neigh => {
                    return neigh.group !== locality.value
                })
            })
        }
        this.handleFilterSearch('')

        let neighbourhoodOptions = [];

        selectedLocality.forEach(data => {
            this.allStates.forEach(state => {
                if (state.city === data.group && state.locality === data.value) {
                    neighbourhoodOptions.push({
                        label: this.titleCase(data.label),
                        options: (state.neighbourhood !== null) ? [
                            { value: state.neighbourhood, label: this.titleCase(state.neighbourhood), group: data.value }
                        ] : []
                    })
                }
            })
        })
        this.handleFilterSearch('')
        this.neighbourhoodOptionsList = this.getSortedOptions(neighbourhoodOptions)
        this.setState({ selectedLocality, neighbourhoodOptions: this.getSortedOptions(neighbourhoodOptions) })

    }

    handleNeighbourhood = (status, neighbourhood) => {
        let selectedNeighbourhood = [...this.state.selectedNeighbourhood]
        if (status)
            selectedNeighbourhood.push(neighbourhood)
        else {
            selectedNeighbourhood = selectedNeighbourhood.filter(n => {
                return !(n.value === neighbourhood.value && n.group === neighbourhood.group)
            })
        }
        this.handleFilterSearch('')
        this.setState({ selectedNeighbourhood })
    }

    grouping = (full_list) => {
        this.grouped_list = [];
        full_list.forEach(function iter(r) {
            return function (o) {
                var ref = r.find(p => o.group === p.group && o.label.toLowerCase() === p.label.toLowerCase());
                if (!ref) {
                    r.push(o);
                    return;
                }
                Object
                    .keys(o)
                    .filter(k => Array.isArray(o[k]))
                    .forEach(k => o[k].forEach(iter(ref[k] = ref[k] || [])));
            };
        }(this.grouped_list));
        return this.grouped_list;
    }

    titleCase = (str) => {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        splitStr = splitStr.join(' ');
        if (splitStr.length >= 30) {
            splitStr = splitStr.slice(0, 30) + '...';
        }

        return splitStr;
    }

    // checkboxLimit = () => {
    //     $(document).ready(function () {
    //         var check = $("input:checkbox:checked").length > 4;
    //         $("input:checkbox").not(":checked").attr("disabled", check);
    //     })
    // }

    getCategoryList = () => {
        return this.state.categoryOptions.map((op, i) =>
            <div id={op.value} key={op.value} className={styles.search_list}>
                <Checkbox checked={this.state.selectedCategory.some(r => r === op.value)} onChange={(e) => this.handleCategory(e.target.checked, op.value)}>{op.label}</Checkbox>
            </div>
        )
    }

    getCheckedCategoryList = () => {
        return this.state.selectedCategory.map((index) => {
            return <div key={index} className={styles.index_content}>{index}</div>;
        });
    }

    getSubCategoryList = () => {
        if (this.state.selectedCategory.length === 0)
            return <h4 className={styles.no_options}>No Category Selected</h4>
        else
            return this.state.subCategoryOptions.map(cat =>
                <div key={cat.label}>
                    <li className={styles.subCat}>
                        <h5 className={styles.options_parent_label}>{cat.label}</h5>
                        {this.getSubCat(cat)}
                    </li>
                </div>
            )
    }

    getSubCat = (cat) => {
        if (cat.options.length === 0) {
            return <div key={cat.label + 'no_op'} className={styles.no_options_multi}><span>No SubCategory Found</span></div>
        } else
            return cat.options.map(op =>
                <div key={op.value} className={styles.search_list}>
                    <Checkbox checked={this.state.selectedSubCategory.some(r => r.group === op.group && r.value === op.value)} onChange={(e) => this.handleSubCategory(e.target.checked, op)}>{op.label}</Checkbox>
                </div>)
    }

    getCheckedSubCategoryList = () => {
        return this.state.selectedSubCategory.map((index) => {
            return <div key={index} className={styles.index_content}>{index.value}</div>;
        });
    }

    getStateList = () => {
        return this.state.stateOptions.map(op =>
            <div key={op.value} className={styles.search_list}>
                <Checkbox checked={this.state.selectedState.some(r => r === op.value)} onChange={(e) => this.handleState(e.target.checked, op.value)}>{op.label}</Checkbox>
            </div>
        )
    }

    getCheckedStateList = () => {
        return this.state.selectedState.map((index) => {
            return <div key={index} className={styles.index_content}>{index}</div>;
        });
    }

    getCityList = () => {
        if (this.state.selectedState.length === 0)
            return <h4 className={styles.no_options}>No State Selected</h4>
        else
            return this.state.cityOptions.map(state =>
                <div key={state.label}>
                    <li className={styles.subCat}>
                        <h5 className={styles.options_parent_label}>{state.label}</h5>
                        {this.getCity(state)}
                    </li>
                </div>
            )
    }

    getCity = (state) => {
        if (state.options.length === 0) {
            return <div key={state.label + 'no_op'} className={styles.no_options_multi}><span>No City Found</span></div>
        } else
            return state.options.map(op =>
                <div key={op.value} className={styles.search_list}>
                    <Checkbox checked={this.state.selectedCity.some(r => r.group === op.group && r.value === op.value)} onChange={(e) => this.handleCity(e.target.checked, op)}>{op.label}</Checkbox>
                </div>)
    }

    getCheckedCityList = () => {
        return this.state.selectedCity.map((index) => {
            return <div key={index} className={styles.index_content}>{index.label}</div>;
        });
    }

    getLocalityList = () => {
        if (this.state.selectedCity.length === 0)
            return <h4 className={styles.no_options}>No City Selected</h4>
        else
            return this.state.localityOptions.map(city =>
                <div key={city.label}>
                    <li className={styles.subCat}>
                        <h5 className={styles.options_parent_label}>{city.label}</h5>
                        {this.getLocality(city)}
                    </li>
                </div>
            )
    }

    getLocality = (city) => {
        if (city.options.length === 0) {
            return <div key={city.label + 'no_op'} className={styles.no_options_multi}><span>No Locality Found</span></div>
        } else
            return city.options.map(op =>
                <div key={op.value} className={styles.search_list}>
                    <Checkbox checked={this.state.selectedLocality.some(r => r.group === op.group && r.value === op.value)} onChange={(e) => this.handleLocality(e.target.checked, op)}>{op.label}</Checkbox>
                </div>)
    }

    getCheckedLocalityList = () => {
        return this.state.selectedLocality.map((index) => {
            return <div key={index} className={styles.index_content}>{index.label}</div>;
        });
    }

    getNeighbourhoodList = () => {
        if (this.state.selectedLocality.length === 0)
            return <h4 className={styles.no_options}>No Locality Selected</h4>
        else
            return this.state.neighbourhoodOptions.map(locality =>
                <div key={locality.label}>
                    <li className={styles.subCat}>
                        <h5 className={styles.options_parent_label}>{locality.label}</h5>
                        {this.getNeighbourhood(locality)}
                    </li>
                </div>
            )
    }

    getNeighbourhood = (locality) => {
        if (locality.options.length === 0) {
            return <div key={locality.label + 'no_op'} className={styles.no_options_multi}><span>No Neighbourhood Found</span></div>
        } else
            return locality.options.map(op =>
                <div key={op.value} className={styles.search_list}>
                    <Checkbox checked={this.state.selectedNeighbourhood.some(r => r.group === op.group && r.value === op.value)} onChange={(e) => this.handleNeighbourhood(e.target.checked, op)}>{op.label}</Checkbox>
                </div>
            )
    }

    getCheckedNeighbourhoodList = () => {
        return this.state.selectedNeighbourhood.map((index) => {
            return <div key={index} className={styles.index_content}>{index.label}</div>;
        });
    }

    menu = (tab) => {
        if (this.state.activeMenu === tab) {
            this.setState({ activeMenu: '' })
        } else {
            this.setState({ activeMenu: tab });
        }
    }

    searchMenu = (checked) => {
        this.catState()
        this.setState({ advancedSearch: checked })
        this.setState({location: null, keyword: null});
    }

    getMenuItems = (tab) => {
        switch (tab) {
            case 'category':
                return this.getCategoryList();
            case 'subcategory':
                return this.getSubCategoryList();
            case 'state':
                return this.getStateList();
            case 'city':
                return this.getCityList();
            case 'locality':
                return this.getLocalityList();
            case 'neighbourhood':
                return this.getNeighbourhoodList();
            default:
                break;
        }
    }

    resetSearchCriteria = () => {
        this.setState({
            selectedCategory: [],
            selectedSubCategory: [],
            selectedState: [],
            selectedCity: [],
            selectedLocality: [],
            selectedNeighbourhood: [],
            radius: 0,
            subCategoryOptions: [],
            cityOptions: [],
            localityOptions: [],
            neighbourhoodOptions: [],
        })
    }

    searchDataHandler = event => {
        event.preventDefault();
        let categories = []
        //if (this.state.selectedCategory.length != []) {
        this.state.selectedCategory.map(data => {
            categories.push(data.replace(',', ''))
        });
        // }
        // else {
        //     notifyUser("Search", "Please Select a Category", type.INFO)
        //     return;
        // }
        let subCategories = []
        if (this.state.selectedSubCategory != []) {
            this.state.selectedSubCategory.map(data => {
                subCategories.push(data.value.replace(',', ''))
            })
        }
        let states = []
        if (this.state.selectedState != []) {
            this.state.selectedState.map(data => {
                states.push(data)
            })
        }
        let cities = []
        if (this.state.selectedCity != []) {
            this.state.selectedCity.map(data => {
                cities.push(data.value)
            })
        }
        let localities = []
        if (this.state.selectedLocality != []) {
            this.state.selectedLocality.map(data => {
                localities.push(data.value)
            })
        }
        let neighbourhoods = []
        if (this.state.selectedNeighbourhood != []) {
            this.state.selectedNeighbourhood.map(data => {
                neighbourhoods.push(data.value)
            })
        }
        const data = {
            category: categories,
            subCategory: subCategories,
            state: states,
            city: cities,
            locality: localities,
            neighbourhood: neighbourhoods,
            country: this.props.current_coords.visitorCountry,
            visitorsState: (localStorage.getItem('state') ? localStorage.getItem('state') : this.props.current_coords.visitorState),
            visitorsCity: localStorage.getItem('city'),
            visitorsLocality: localStorage.getItem('locality'),
            visitorsNeighbourhood: localStorage.getItem('neighbourhood'),
            ...this.props.current_coords,
            distance: this.state.radius,
            offset: 0,
            num_rows: 10,
            businessPackage: null,
            featured: true,
            keyword: this.state.keyword,
            location: this.state.location,
            userId: authservice.getCurrentUserid(),
            guestId: this.state.userId ? null : authservice.getCookie('hp.rocks.soon'),

        }

        this.setState({ activeMenu: '', showMenu: false })

        if (parseInt(this.state.radius) || categories.length || subCategories.length || states.length || cities.length || localities.length || neighbourhoods.length || this.state.keyword || this.state.location) {
            if (parseInt(this.state.radius) && !states.length) {
                return !data.latitude ? (
                    notifyUser("Geolocation", "Geolocation is not enabled...!", type.WARNING)
                ) : this.props.history.push('/search', {
                    searchRequest: data,
                    searchCriteria: "searching",
                })
            } else {
                this.props.history.push('/search', {
                    searchRequest: data,
                    searchCriteria: "searching",
                })
            }
        }
    }

    renderDesktopView() {
        return (
            <div className={`row form-row col-md-12 pr-0`}>
                <div className={styles.multi_select} style={{width:"-webkit-fill-available"}}>
                    <ul className="nav nav-tabs listing_search_tabs" role="tablist" style={{width:"-webkit-fill-available"}}>
                        <div className="search_tab" style={{width:"-webkit-fill-available"}}>
                            <div className={styles.search_container}>
                                <ul className={`search_list ${styles.search_tab_ul}`} style={{width:"-webkit-fill-available"}}>
                                    <li className={`col-2 ${styles.search_tab_li}`}><a className={`nav-link ${styles.search_tab_a} ${(this.state.activeMenu === 'category') ? 'active' : ''} ml-auto mr-auto`}
                                        data-toggle="tab" role="tab" onClick={() => this.menu("category")}>
                                        Category <i className='button_space fa fa-caret-down'></i></a></li>
                                    <li className={`col-2 ${styles.search_tab_li}`}><a className={`nav-link ${styles.search_tab_a} ${(this.state.activeMenu === 'subcategory') ? 'active' : ''} ml-auto mr-auto`}
                                        data-toggle="tab" role="tab" onClick={() => this.menu("subcategory")}>
                                        SubCategory <i className='button_space fa fa-caret-down' ></i></a></li>
                                    <li className={`col-2 ${styles.search_tab_li}`}><a className={`nav-link ${styles.search_tab_a} ${(this.state.activeMenu === 'state') ? 'active' : ''} ml-auto mr-auto`}
                                        data-toggle="tab" role="tab" onClick={() => this.menu("state")}>
                                        State <i className='button_space fa fa-caret-down'></i></a></li>
                                    <li className={`col-2 ${styles.search_tab_li}`}><a className={`nav-link ${styles.search_tab_a} ${(this.state.activeMenu === 'city') ? 'active' : ''} ml-auto mr-auto`}
                                        data-toggle="tab" role="tab" onClick={() => this.menu("city")}>
                                        City <i className='button_space fa fa-caret-down'></i></a></li>
                                    <li className={`col-2 ${styles.search_tab_li}`}><a className={`nav-link ${styles.search_tab_a} ${(this.state.activeMenu === 'locality') ? 'active' : ''} ml-auto mr-auto`}
                                        data-toggle="tab" role="tab" onClick={() => this.menu("locality")}>
                                        Locality <i className='button_space fa fa-caret-down'></i></a></li>
                                    <li className={`col-2 ${styles.search_tab_li}`}><a className={`nav-link ${styles.search_tab_a} ${(this.state.activeMenu === 'neighbourhood') ? 'active' : ''} ml-auto mr-auto`}
                                        data-toggle="tab" role="tab" onClick={() => this.menu("neighbourhood")}>
                                        Neighbourhood <i className='button_space fa fa-caret-down'></i></a></li>
                                </ul>
                                <div className={styles.search_btns}>
                                    <div className={`${styles.search_button_col} range_input`}>
                                        <input className={styles.range_input_input} id="test" type="range" min="0" max="10"
                                            onChange={(event) => this.setState({ radius: event.target.value })}
                                            value={this.state.radius} data-tooltip={this.state.radius + ' Km\'s'} />
                                    </div>
                                    <div className={styles.search_button_col}>
                                        <button type="reset" onClick={this.resetSearchCriteria} className={`btn btn-info ${styles.search_button}`}><i className="fa fa-refresh"></i></button>
                                    </div>
                                    <div className={styles.search_button_col}>
                                        <ButtonStyle type="submit" className={`btn ${styles.submit_button}`} style={{width:"max-content"}}><i className="fa fa-search"></i> &nbsp; Search</ButtonStyle>
                                    </div>
                                </div>
                            </div>
                            {this.state.activeMenu.length ?
                                <div className={styles.dropdown_content} style={{left:"40px"}}>

                                    {(this.state.activeMenu === 'category') ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedCategoryList()}
                                            </div>
                                        </div> : null}
                                    {(this.state.activeMenu === 'subcategory') ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedSubCategoryList()}
                                            </div>
                                        </div> : null}
                                    {(this.state.activeMenu === 'state') ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedStateList()}
                                            </div>
                                        </div> : null}
                                    {(this.state.activeMenu === 'city') ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedCityList()}
                                            </div>
                                        </div> : null}
                                    {(this.state.activeMenu === 'locality') ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedLocalityList()}
                                            </div>
                                        </div> : null}
                                    {(this.state.activeMenu === 'neighbourhood') ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedNeighbourhoodList()}
                                            </div>
                                        </div> : null}
                                    <div className={styles.filter}>
                                        {this.getMenuItems(this.state.activeMenu)}
                                        {/* {this.checkboxLimit()} */}
                                    </div>
                                </div>
                                : null}
                        </div>
                    </ul>
                </div>
            </div>
        )
    }

    handleMenuClick = () => {
        this.setState({ showMenu: !this.state.showMenu })
    }

    renderMobileView() {
        return (
            <div className="topbar">
                <div className={`nav-mobile ${styles.nav_mobile} ${styles.mobile_search}`} onClick={this.handleMenuClick} style={{display: window.innerWidth<950 ? "flex" : "" }}>
                    <div id="nav-toggle" className={this.state.showMenu ? 'active' : ''}><span></span></div>
                    {/* <span className='menu'>Menu</span> */}
                    <span className='menu m-0' style={{position:"relative", fontSize:"22px", left:"45px"}}>Menu</span>
                </div>
                <div className={`search_btn ${styles.mobile_div} justify-content-end`}>
                     {/* style={{justifyContent:"end"}}> */}
                    <div className="search_button_col">
                        <button type="reset" onClick={this.resetSearchCriteria} className="btn btn-info search_button"><i className="fa fa-refresh"></i></button>
                    </div>
                    <div className="search_button_col">
                        <button type="submit" className={`btn btn-warning lookup_button ${styles.mobileview_submit}`} id="lookup"><i className="fa fa-search"></i> &nbsp; Search</button>
                    </div>
                </div>
                <div className="col-md-12 float-left collapse width" id="sidebar" style={this.state.showMenu ? { display: 'contents',paddingBottom: "10px", marginTop:"13px" } : null}>
                    <div className={`col-md-1 payment_container searchRound`}>
                        <label className="switch">
                            <input type="checkbox" id="advancedSearch" onClick={event => { this.searchMenu(event.target.checked) }} />
                            <span className="slider round mobile_searchSlider">
                                <p className="button_on text-center" style={{ marginRight: '5px' }}>Advanced Search</p>
                            </span>
                        </label>
                    </div>
                    {this.state.advancedSearch ?
                    //  null 
                    <div className="row d-flex d-md-block flex-nowrap wrapper">


                        <div className="col-md-12 float-left collapse width" id="sidebar" style={this.state.showMenu ? { display: 'block' } : null}>
                            <ul className={`collapse_menu ${styles.mobileview_display}`}>
                                <li><a className={`nav-link ${(this.state.activeMenu === 'category') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("category")} >
                                    Category <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'category' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedCategoryList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            {/* {this.checkboxLimit()} */}
                                        </div> : null}
                                </li>
                                <li><a className={`nav-link ${(this.state.activeMenu === 'subcategory') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("subcategory")}>
                                    SubCategory <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'subcategory' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedSubCategoryList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            {/* {this.checkboxLimit()} */}
                                        </div> : null}
                                </li>
                                {this.props.is_login ? null : <li><a className={`nav-link ${(this.state.activeMenu === 'state') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("state")}>
                                    State <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'state' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedStateList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            {/* {this.checkboxLimit()} */}
                                        </div> : null}
                                </li>}
                                {this.props.is_login ? null : <li><a className={`nav-link ${(this.state.activeMenu === 'city') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("city")}>
                                    City <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'city' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedCityList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            {/* {this.checkboxLimit()} */}
                                        </div> : null}
                                </li>}
                                {this.props.is_login ? null : <li><a className={`nav-link ${(this.state.activeMenu === 'locality') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("locality")}>
                                    Locality <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'locality' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedLocalityList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            {/* {this.checkboxLimit()} */}
                                        </div> : null}
                                </li>}
                                {this.props.is_login ? null : <li><a className={`nav-link ${(this.state.activeMenu === 'neighbourhood') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("neighbourhood")}>
                                    Neighbourhood <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'neighbourhood' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedNeighbourhoodList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            {/* {this.checkboxLimit()} */}
                                        </div> : null}
                                </li>}
                            </ul>
                        </div>
                    </div>

                     :
                        <div className='mobile_keyword'>
                            <div><input className='col-md-12' placeholder='FIND (e.g. biryani, driver)' name="keyword" onChange={(event) => this.setState({ keyword: event.target.value })} noValidate required value={this.state.keyword}></input></div>
                            <div><input className='col-md-12' placeholder='LOCATION (Colony, Locality, City or State)' name="location" onChange={(event) => this.setState({ location: event.target.value })} noValidate value={this.state.location}></input></div>
                        </div>}
                </div>

                {/* {this.state.advancedSearch ?
                    <div className="row d-flex d-md-block flex-nowrap wrapper">


                        <div className="col-md-12 float-left collapse width" id="sidebar" style={this.state.showMenu ? { display: 'block' } : null}>
                            <ul className={`collapse_menu ${styles.mobileview_display}`}>
                                <li><a className={`nav-link ${(this.state.activeMenu === 'category') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("category")} >
                                    Category <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'category' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedCategoryList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            
                                        </div> : null}
                                </li>
                                <li><a className={`nav-link ${(this.state.activeMenu === 'subcategory') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("subcategory")}>
                                    SubCategory <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'subcategory' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedSubCategoryList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            
                                        </div> : null}
                                </li>
                                {this.props.is_login ? null : <li><a className={`nav-link ${(this.state.activeMenu === 'state') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("state")}>
                                    State <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'state' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedStateList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            
                                        </div> : null}
                                </li>}
                                {this.props.is_login ? null : <li><a className={`nav-link ${(this.state.activeMenu === 'city') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("city")}>
                                    City <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'city' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedCityList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            
                                        </div> : null}
                                </li>}
                                {this.props.is_login ? null : <li><a className={`nav-link ${(this.state.activeMenu === 'locality') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("locality")}>
                                    Locality <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'locality' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedLocalityList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            
                                        </div> : null}
                                </li>}
                                {this.props.is_login ? null : <li><a className={`nav-link ${(this.state.activeMenu === 'neighbourhood') ? 'active' : ''}`}
                                    data-toggle="tab" role="tab" onClick={() => this.menu("neighbourhood")}>
                                    Neighbourhood <i className='button_space fa fa-caret-down'></i></a>
                                    {this.state.activeMenu === 'neighbourhood' ?
                                        <div>
                                            <input type="text" className="form-control" id="key_search" name="key_search"
                                                onChange={(e) => this.handleFilterSearch(e.target.value)} value={this.state.searchText}
                                                placeholder="Search for..." />
                                            <div className={styles.input_content}>
                                                {this.getCheckedNeighbourhoodList()}
                                            </div>
                                            {this.getMenuItems(this.state.activeMenu)}
                                            
                                        </div> : null}
                                </li>}
                            </ul>
                        </div>
                    </div> : null} */}
            </div>
        )
    }



    render() {
        const {  ismobile } = this.state;
        const keywordSearch =
            <>
                <div className='col-md-1'></div>
                <input className='col-md-4' placeholder='FIND (e.g. biryani, driver)' name="keyword" onChange={(event) => this.setState({ keyword: event.target.value })} noValidate required value={this.state.keyword}></input>&nbsp; &nbsp;
                <input className='col-md-4' placeholder='LOCATION (Colony, Locality, City or State)' name="location" onChange={(event) => this.setState({ location: event.target.value })} noValidate value={this.state.location}></input>
                {/* &nbsp; &nbsp; */}
                <div className={`${styles.search_button_col} col-2`}>
                    <ButtonStyle type="submit" className={`btn ${styles.submit_button}`}><i className="fa fa-search"></i> &nbsp; Search</ButtonStyle>
                </div>
            </>

        let classHide = this.state.isHide ? "scrolled-down" : "scrolled-up"
        return (
            <>
                <div className="topbar" style={{position:  window.innerWidth <= 1280 ? "sticky" : "fixed" }}>
                    <div className={styles.header}>
                        <div className={styles.bottom_strip}>
                            <div className={`grid_system ${styles.grid_container} ${styles.search_strip}`}>

                                {
                                // this.props.isMobile 
                                ismobile
                                ? <form onSubmit={this.searchDataHandler}> {this.renderMobileView()} </form> :
                                    <div>
                                        <div className='row'>
                                            <div className="col-md-1 payment_container searchRound">
                                                <label className="switch">
                                                    <input type="checkbox" id="advancedSearch" onClick={event => { this.searchMenu(event.target.checked) }} />
                                                    <span className="slider round searchSlider">
                                                        <p className="button_on text-center" style={{ marginRight: '5px' }}>Advanced Search</p>
                                                    </span>
                                                </label>
                                            </div>
                                            {this.state.advancedSearch ? <form className='col-md-11 pr-0' onSubmit={this.searchDataHandler}> {this.renderDesktopView()} </form> : <form className='row col-md-10 ml-auto mr-0' onSubmit={this.searchDataHandler}>{keywordSearch}</form>}

                                        </div>
                                    </div>}

                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        current_coords: state.current_coords,
        is_login: state.is_login,
    }
}
export default (connect(mapStateToProps, null)(Search));